/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { bool, object } from 'prop-types';

import { makeStyles } from '@material-ui/core';
import MarkdownText from './MarkdownText';
import useOfferGatewayClickHandler from '../../../../GraphqlCommonComponents/GenericDialog/OfferGateway/useOfferGatewayClickHandler';

const useStyles = makeStyles((theme) => ({
    heading: (styles) => ({
        fontSize: styles?.headingFontSize || '18px',
    }),
    fixedHeader: {
        position: 'sticky',
        top: 0,
        width: 'calc(414px - 44px)',
        marginBottom: '1px',
        background: 'white',
        padding: '24px 0 16px',
        zIndex: 2,
        [theme.breakpoints.down('sm')]: {
            padding: '16px 0',
            width: 'calc(100vw - 28px)',
        },
    },
    emptyHeader: {
        height: '24px',
    },
}));

const OfferHeader = ({
    offer, firstItem,
}) => {
    const isOffergateway = offer?.type === 'offer-gateway';

    const heading = isOffergateway ? offer?.content?.heading : offer?.heading;
    let subHeading = isOffergateway ? offer?.content?.sub_heading : offer?.sub_heading;
    const campaignPayload = offer?.campaign?.campaignResponses?.[0]?.payload || {};
    const isUnlocked = campaignPayload?.offerFlow === 'Offer Unlocked';
    subHeading = isUnlocked ? '' : subHeading;

    const classes = useStyles({
        headingFontSize: heading?.font_size,
    });

    const { handleOfferInboxClick } = useOfferGatewayClickHandler(offer);

    const clickHandler = (e) => {
        e.preventDefault();
        handleOfferInboxClick();
    };

    if (heading?.copy || subHeading?.copy) {
        return (
            <div className={classes.fixedHeader}>
                {heading?.copy && (<h2 className={classes.heading}>{heading?.copy}</h2>)}
                {subHeading?.copy && (
                    <MarkdownText data={subHeading} handleClick={clickHandler} />
                )}
            </div>
        );
    }

    if (firstItem) return null; // don't render empty space for first item if no heading or subheading
    return <div className={classes.emptyHeader} />;
};

OfferHeader.propTypes = {
    offer: object,
    firstItem: bool,
};

OfferHeader.defaultProps = {
    offer: {},
    firstItem: false,
};

export default OfferHeader;
